<template>
<footer role="contentinfo" ref="footer">
    <div class="container">
        <p class="text-center footer-title">Retrouvez moi sur les réseaux sociaux</p>
       <div class="d-flex gap-20 jcc">
         <FooterBtn v-for="network in rxsx" :href="network.link" :type="network.type" :title="network.title"/>
       </div>
    </div>
</footer>
</template>
<script setup lang='ts'>

const rxsx = [
    {
        type: "linkedin",
        link: "https://www.linkedin.com/in/pauline-fuchs",
        title:"Voir mon profil Linkedin"
    },
    {
        type: "behance",
        link: "https://www.behance.net/paulinefuchs",
        title:'Voir mon profil Behance'
    },
    {
        type: "insta",
        link: "https://www.instagram.com/paufuchs_/",
        title:"Voir mon profil Instagram"
    }
]
const footer = useAnimateOnVisible("animate__fadeInUp")
</script>
<style lang="scss">
    footer{
        padding: 50px 0;
        position:  relative;
        opacity: 0;
        @media screen and (max-width:550px){
            padding: 20px 0;
        }
        .container{
            &:before{
            content: '';
            width: 120px;
            height: 185px;
            position: absolute;
            bottom: -55px;
            left: 10%;
            background-repeat: no-repeat;
            background-position: center center;
            background-image: url("~/assets/svgs/footer-flower.svg");   
            @media screen and (max-width:1035px) {
                height: 115px;
                background-size: contain;
                bottom: -50px;
                left: 0;
            } 
            @media screen and (max-width:550px) {
                height: 65px;
                left:-40px;
                bottom: -25px;
            } 
        }
        
        }
        .footer-title{
            color: $gray;
            font-size: 18px;
            font-weight: 500;
            margin-bottom:1rem;
            @media screen and (max-width:550px) {
                font-size: 16px;
            }
        }
    }
</style>